














import Vue from "vue";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    props: {
        focusable: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    computed: {
        seeAllUrl: function(): string {
            switch(Trans.currentLocale) {
            case "fr":
                return `./classifieds#/${Trans.currentLocale}/mes-annonces`;
            case "nl":
                return `./classifieds#/${Trans.currentLocale}/mijn-zoekertjes`;
            default:
                return `./classifieds#/${Trans.currentLocale}/my-classifieds`;
            }
        }
    }
});
